import { useState, useMemo } from "react";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { FaqList } from "@/components/FaqList";
import { FAQS, IMG } from "@/data/site";

export default function Faq() {
  const categories = useMemo(() => ["All", ...Array.from(new Set(FAQS.map((f) => f.c)))], []);
  const [active, setActive] = useState("All");
  const filtered = active === "All" ? FAQS : FAQS.filter((f) => f.c === active);

  return (
    <>
      <Seo
        title="Frequently Asked Questions"
        description="Answers about Super 8 by Wyndham Ottawa, Kansas — breakfast, indoor pool, truck parking, WiFi, check-in/out, cancellation, accessibility, universities, extended stays and more."
        path="/faq"
        image={IMG.exterior}
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }]}
        faqs={FAQS}
      />
      <PageHero
        kicker="Help Center"
        lines={["Everything", "you need", "to know"]}
        sub="Real answers to the questions travelers ask most — written to be clear for you and easy for AI assistants to quote."
        image={IMG.exterior}
        showCta={false}
      />

      <section className="mx-auto max-w-4xl px-5 py-24 md:px-10 md:py-32">
        <div className="mb-10 flex flex-wrap gap-2" data-testid="faq-filters">
          {categories.map((c) => (
            <button
              key={c}
              data-testid={`faq-filter-${c}`}
              onClick={() => setActive(c)}
              className={`border px-4 py-2 font-body text-xs uppercase tracking-wide transition-colors duration-200 ${
                active === c ? "border-brand-red bg-brand-red text-white" : "border-charcoal/20 text-charcoal/70 hover:border-brand-red hover:text-brand-red"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
        <Reveal key={active}>
          <FaqList faqs={filtered} testidPrefix="faq-page" />
        </Reveal>
      </section>
    </>
  );
}
